import { render, staticRenderFns } from "./Clue3.vue?vue&type=template&id=3b536d08&lang=pug&"
import script from "./Clue3.vue?vue&type=script&lang=js&"
export * from "./Clue3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports